import styles from "./EmptyState.module.css";

type EmptyStateProps = {
  variant: "error" | "empty" | "info";
  title: string;
  message?: string;
  icon?: React.ReactNode;
  action?: {
    label: string;
    onClick: () => void;
  };
};

function ErrorIcon() {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="32" cy="32" r="30" stroke="#ef4444" strokeWidth="4" fill="none" />
      <path d="M22 22L42 42M42 22L22 42" stroke="#ef4444" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}

function EmptyIcon() {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="8" y="14" width="48" height="36" rx="2" stroke="#9ca3af" strokeWidth="3" />
      <path d="M8 22H56" stroke="#9ca3af" strokeWidth="3" />
      <path
        d="M32 36C32 36 24 30 24 30L32 24L40 30C40 30 32 36 32 36Z"
        stroke="#9ca3af"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function InfoIcon() {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="32" cy="32" r="30" stroke="#3b82f6" strokeWidth="4" fill="none" />
      <path d="M32 20V22M32 28V44" stroke="#3b82f6" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}

export default function EmptyState({ variant, title, message, icon, action }: EmptyStateProps) {
  const defaultIcon = icon || (
    <>
      {variant === "error" && <ErrorIcon />}
      {variant === "empty" && <EmptyIcon />}
      {variant === "info" && <InfoIcon />}
    </>
  );

  return (
    <div className={`${styles.container} ${styles[variant]}`}>
      <div className={styles.iconWrapper}>{defaultIcon}</div>
      <h2 className={styles.title}>{title}</h2>
      {message && <p className={styles.message}>{message}</p>}
      {action && (
        <button type="button" onClick={action.onClick} className={styles.actionButton}>
          {action.label}
        </button>
      )}
    </div>
  );
}
